<template>
  <div class="deal_box">
    <!-- 分割线 -->
    <div class="cut_off"></div>
    <!-- 内容 -->
    <div class="deal_show_box">
      <!-- 左边 deal_left -->
      <div class="deal_left">
        <!-- 用户头像区块 -->
        <div class="deal_user">
          <div class="deal_user_photo">
            <img src="../../../assets/img/common/photo_replace.png" alt="">
          </div>
          <div class="deal_user_name">{{this.$store.state.storename}}</div>
          <div class="deal_user_id">UID：{{this.$store.state.uid}}</div>
          <!-- deal_user -->
        </div>
        <!-- 下拉菜单 -->
        <div class="drop_down_box">
          <!-- 1-交易管理 -->
          <div :class="dropActive == 1?'drop_box drop_management drop_active': 'drop_box drop_management'">
            <div class="drop_down_title" @click="dropDown(1)">
              <img src="../../../assets/img/login/drop_down_icon1.png" alt="">交易管理<i :class="dropActive == 1?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
            </div>
            <ul class="drop_down_content" v-show="dropActive == 1">
              <li :class="active == '1-1' ?'active':'' " @click="activeFun('1-1','')">· 交易訂單</li>
              <li :class="active == '1-2' ?'active':'' " @click="activeFun('1-2','refund')" v-show="false">· 申請退款</li>
              <li :class="active == '1-3' ?'active':'' " @click="activeFun('1-3','inquire')" v-show="false">· 退款查詢</li>
              <li :class="active == '1-4' ?'active last':'last' " @click="activeFun('1-4','setting')" v-show="false">· 退款設定</li>
              <li :class="active == '1-5' ?'active last':'last' " @click="activeFun('1-5','recharge')">· 充值訂單</li>
            </ul>
          </div>
          <!-- 2-結算管理 -->
          <div :class="dropActive == 2?'drop_box drop_settlement drop_active':'drop_box drop_settlement'">
            <div class="drop_down_title" @click="dropDown(2)">
              <img src="../../../assets/img/login/drop_down_icon2.png" alt="">結算管理<i :class="dropActive == 2?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
            </div>
            <ul class="drop_down_content" v-show="dropActive == 2">
              <li :class="active == '2-1' ?'active last':'last' " @click="activeFun('2-1','settlement')">· 提領管理</li>
            </ul>
          </div>
          <!-- 3-帳單管理 -->
          <div :class="dropActive == 3?'drop_box drop_bill drop_active':'drop_box drop_bill'">
            <div class="drop_down_title" @click="dropDown(3)">
              <img src="../../../assets/img/login/drop_down_icon3.png" alt="">帳單管理<i :class="dropActive == 3?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
            </div>
            <ul class="drop_down_content" v-show="dropActive == 3">
              <li :class="active == '3-1' ?'active':'' " @click="activeFun('3-1','bills')">· 交易帳單</li>
              <li :class="active == '3-2' ?'active last':'last' " @click="activeFun('3-2','moneybills')">· 資金帳單</li>
            </ul>
          </div>
          <!-- 4-資金管理 -->
          <div :class="dropActive == 4?'drop_box drop_fund drop_active':'drop_box drop_fund'">
            <div class="drop_down_title" @click="dropDown(4)">
              <img src="../../../assets/img/login/drop_down_icon4.png" alt="">資金管理<i :class="dropActive == 4?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
            </div>
            <ul class="drop_down_content" v-show="dropActive == 4">
              <!-- <li :class="active == '4-1' ?'active':'' " @click="activeFun('4-1','shift')">· 儲值/轉入</li> -->
              <li :class="active == '4-2' ?'active':'' " @click="activeFun('4-2','rolloff')">· 提現/轉出</li>
              <li :class="active == '4-3' ?'active':'' " @click="activeFun('4-3','record')">· 提現/轉出記錄</li>
              <li :class="active == '4-4' ?'active':'' " @click="activeFun('4-4','statement')">· 帳戶流水</li>
              <!-- <li :class="active == '4-5' ?'active last':'last' " @click="activeFun('4-5','freeze')">· 凍結資金管理</li> -->
            </ul>
          </div>
          <!-- 5-憑據管理 -->
          <div :class="dropActive == 5?'drop_box drop_voucher drop_active':'drop_box drop_voucher'">
            <div class="drop_down_title" @click="dropDown(5)">
              <img src="../../../assets/img/login/drop_down_icon5.png" alt="">憑據管理<i :class="dropActive == 5?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
            </div>
            <ul class="drop_down_content" v-show="dropActive == 5">
              <li :class="active == '5-1' ?'active last':'last' " @click="activeFun('5-1','certificates')">· 電子憑證</li>
            </ul>
          </div>
          <!-- drop_down_box -->
        </div>
        <!-- deal_left -->
      </div>
      <!-- 右边区块 -->
      <div class="deal_right">
        <router-view @moneybillsFun="moneybillsFun()" @rolloffFun="rolloffFun()"></router-view>
      </div>
      <!-- 内容 -->
    </div>
    <!-- deal_box -->
  </div>
</template>

<script>

export default {
  name: 'logindeal',
  props: {

  },
  data() {
    return {
      userName: "這裡是商家簡稱",
      userId : 87775476,
      dropDownShow: false,
      dropActive: sessionStorage.dropActive || 1,
      active: sessionStorage.numberactive || '1-1',
    }
  },
  created(){
    this.active = '1-1';
    this.$router.push('/login/deal');
  },
  components: {

  },
  methods: {
    dropDown(index){
      this.dropActive = index;
      sessionStorage.dropActive = index;
    },
    activeFun(index, url){
      this.active = index;
      sessionStorage.numberactive = index;
      this.$router.push('/login/deal/'+url);
    },
    // 
    moneybillsFun(){
      this.dropActive = 4;
      sessionStorage.dropActive = 4;
      this.active = '4-4';
      sessionStorage.numberactive = '4-4';
    },
    rolloffFun(){
      this.dropActive = 4;
      sessionStorage.dropActive = 4;
      this.active = '4-2';
      sessionStorage.numberactive = '4-2';
    }
  },
  mounted() {
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*  */
  .deal_box {
    background: #f3f3f3;
    overflow: hidden;
  }
  .cut_off {
    height: 4px;
    background: #e73262;
  }
/*  */
.deal_show_box {
  display: flex;
  
}
/* left */
  .deal_left {
    width: 220px;
    min-width: 220px;
    min-height: 700px;
    background: #393857;
    font-size: 13px;
    color: #ffffff;
  }
  .deal_user {
    box-sizing: border-box;
    height: 264px;
    font-size: 13px;
    letter-spacing: 1px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 0;
  }
  .deal_user .deal_user_photo {
    width: 140px;
    height: 140px;
    background: url("../../../assets/img/common/user_photo.png") center no-repeat;
    background-size: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
  .deal_user .deal_user_photo img {
    width: 25px;
    height: 25px;
  }
  .deal_user .deal_user_name {
    font-size: 15px;
    margin-top: 24px;
    margin-bottom: 10px;
  }
/* 下拉菜单 */
  .drop_box {
    /* background: #30304c; */
    text-align: center;
    overflow: hidden;
    box-sizing: border-box;
  }
  .drop_active {
    background: #30304c;
  }
  .drop_down_title {
    cursor: pointer;
    box-sizing: border-box;
    font-size: 15px;
    margin-top: 20px;
  }
  .drop_down_title img {
    box-sizing: border-box;
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .drop_down_title i {
    box-sizing: border-box;
    text-align: center;
    margin-left: 40px;

  }
  .drop_down_content li {
    text-align: left;
    margin-left: 71px;
    cursor: pointer;
    font-size: 13px;
    padding: 8px 0;
  }
  .drop_down_content .active {
    border-right: 6px solid #e73262;
    color: #e73262;
    box-sizing: border-box;
  }
  .drop_down_content .last {
    margin-bottom: 8px;
  }
/* right */
  .deal_right {
    width: 84.5vw;
  }
</style>
